import {
    isActivitiesPage,
    isUserDefaultActivityPage,
} from "@khan/guide-core-helpers";
import {UserPersona} from "@khan/guide-types";

/* A helper to determine if we should apply special styling to the chat bubble */
export const getShouldStyleAsStudentMode = (
    userAsStudent: boolean,
    isIncoming: boolean,
    pathname: string,
    defaultPersona: UserPersona | null,
) => {
    const defaultActivityPage =
        defaultPersona && isUserDefaultActivityPage(pathname, defaultPersona);
    return (
        userAsStudent &&
        isIncoming &&
        (defaultActivityPage ||
            (defaultPersona === UserPersona.Teacher &&
                !isActivitiesPage(pathname)))
    );
};
